import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dbeba7b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "call-ended"
}
const _hoisted_2 = { class: "info-wrap" }
const _hoisted_3 = { class: "avatar-wrap" }
const _hoisted_4 = {
  key: 0,
  class: "text-wrap"
}
const _hoisted_5 = {
  key: 1,
  class: "error-container"
}
const _hoisted_6 = { class: "call-buttons" }
const _hoisted_7 = {
  key: 1,
  class: "call-collapsed"
}
const _hoisted_8 = { class: "error-text-wrap" }
const _hoisted_9 = { class: "call-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Typography = _resolveComponent("Typography")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Hint = _resolveComponent("Hint")!

  return (!_ctx.settingsState?.minimize)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.showError)
          ? (_openBlock(), _createBlock(_component_Typography, {
              key: 0,
              class: "title"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t(`${_ctx.selectCall.direction}`)), 1)
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_Typography, {
              key: 1,
              class: "title"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('callEndedTitle')), 1)
              ]),
              _: 1
            })),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Icon, {
              color: "--sui-gray-400",
              name: "ic24-user",
              width: "42",
              height: "46"
            })
          ]),
          (_ctx.selectCall)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_Typography, { class: "phone-number" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.selectCall.number), 1)
                  ]),
                  _: 1
                }),
                (!_ctx.showError)
                  ? (_openBlock(), _createBlock(_component_Typography, {
                      key: 0,
                      class: "duration"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('duration')) + ": " + _toDisplayString(_ctx.callTime), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.showError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createVNode(_component_Icon, {
                        color: "--sui-red-500",
                        name: "ic24-error-fill",
                        width: "20",
                        height: "20"
                      }),
                      _createVNode(_component_Typography, { fontColor: "--sui-red-500" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.selectCall.status) + " · " + _toDisplayString(_ctx.errorText), 1)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Button, {
            mode: "success",
            onClick: _ctx.redialCall
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('redial')), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_Button, {
            mode: "flat",
            onClick: _ctx.closeSelectCall
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('cancel')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_7, [
        _createVNode(_component_Hint, {
          class: _normalizeClass(["hint-phone", {'error-text': _ctx.showError}]),
          text: _ctx.showError ? _ctx.errorText : _ctx.selectCall.number
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              (_ctx.showError)
                ? (_openBlock(), _createBlock(_component_Icon, {
                    key: 0,
                    color: "--sui-red-500",
                    name: "ic24-error-fill",
                    width: "20",
                    height: "20"
                  }))
                : _createCommentVNode("", true),
              (_ctx.selectCall)
                ? (_openBlock(), _createBlock(_component_Typography, {
                    key: 1,
                    class: "phone-number",
                    fontColor: _ctx.showError && '--sui-red-500'
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.selectCall.number), 1)
                    ]),
                    _: 1
                  }, 8, ["fontColor"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["class", "text"]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_Hint, {
            text: _ctx.t('cancel')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Button, {
                mode: "secondary",
                iconOnly: "",
                icon: {name: 'ic20-close', color: '--sui-gray-700'},
                onClick: _ctx.closeSelectCall
              }, null, 8, ["onClick"])
            ]),
            _: 1
          }, 8, ["text"]),
          _createVNode(_component_Hint, {
            text: _ctx.t('redial')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Button, {
                mode: "success",
                icon: { name: 'ic20-phone', color: '--sui-white' },
                iconOnly: "",
                onClick: _ctx.redialCall
              }, null, 8, ["onClick"])
            ]),
            _: 1
          }, 8, ["text"])
        ])
      ]))
}